import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './settings-tab.module.scss';

const SettingsTab = ({ tabs = [], onClick }) => {
    const { t } = useTranslation(['global', 'kyc']);
    return (
        <div className={styles.container}>
            {(tabs || []).map((tab) => {
                const { id, tabHeader } = tab || {};
                const isActive = tab?.selected;
                return (
                    <div key={id} className={`${styles.header} ${isActive ? styles.active : ''} fs-14`} onClick={() => onClick(id)}>
                        {t(tabHeader)}
                    </div>
                );
            })}
        </div>
    );
};

export default SettingsTab;
